import HomeScreen from "../HomeScreen/HomeScreen";
import ClassplusLogo from "../../assets/Images/classplus-logo.png";
import { AndroidScreen } from "../../components/AndroidScreen";
import { useState, useEffect } from "react";
import {conversationsEG } from "../../data/contents";
import { ButtonTexts } from "../../data/contents";
import SouravDadaImage from "../../assets/Images/Ganguly.png";
import messageEdit from "../../assets/Images/message-edit.svg";
import playCircle from "../../assets/Images/play-cricle.svg";
import announce from "../../assets/Images/Announce.svg";
import name from "../../assets/Images/name.svg";
import globe from "../../assets/Images/globe.png";
import "./Style.css";
import { baseUrl } from "../../utils/api";
import axios from "axios";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import tablet from "../../assets/Images/tablet 1.png"

const DesktopScreen = () => {
  const [uid , setUid] = useState("")
  const [language, setLanguage] = useState("EN")
  const [headingTexts , setHeadingTexts] = useState()
  const [numberSubmitted, setNumberSubmitted] = useState(false);
  const [instituteName, setInstituteName] = useState("");
  const [headingText, setHeadingText] = useState();
  const [buttonText, setButtonText] = useState("English")
  const [showButton, setShowButton] = useState(false)
  const { t } = useTranslation();
  // const [communityUrls, setCommunityUrls]=useState('https://clsps.link/iWBcv0')
  const [communityUrls, setCommunityUrls]=useState('https://clps.app/eNUp')
  const [apilanguage, setApilanguage]=useState()
  const [showDadaImage, setShowDadaImage] = useState(true);

  useEffect(() => {
    const url = new URL(window.location.href);
    let utm_source = url.searchParams.get("utm_source");
    let utm_campaign = url.searchParams.get("utm_campaign");
    let utm_medium = url.searchParams.get("utm_medium");
    let utm_content = url.searchParams.get("utm_content");
    let utm_term = url.searchParams.get("utm_term");
    let gclID = url.searchParams.get("gclid");
    getUUID(utm_campaign, utm_medium, utm_source, utm_content, utm_term, gclID);
  }, []);

  const hideDadaImage = () => {
    setShowDadaImage(false);
  }

  const getUUID = async (
    utm_campaign,
    utm_medium,
    utm_source,
    utm_content,
    utm_term,
    gclID
  ) => {
    try {
      const fbp = document.cookie
        .split(";")
        .filter((c) => c.includes("_fbp="))
        .map((c) => c.split("_fbp=")[1]);
      const fbc = document.cookie
        .split(";")
        .filter((c) => c.includes("_fbc="))
        .map((c) => c.split("_fbc=")[1]);

      let fbpCookie = fbp && fbp[0];
      let fbcCookie = fbc && fbc[0];

      const { data } = await axios.post(`${baseUrl}/growth/saveLead`, {
        utm_campaign,
        utm_medium,
        utm_source,
        utm_content,
        utm_term,
        gclId: gclID,
        fbp: fbpCookie,
        fbc: fbcCookie,
        leadIntent:"clp-old",
      });
      setUid(data?.data);
      const lang=data?.data?.languageDetails?.language?.toUpperCase() ? data?.data?.languageDetails?.language?.toUpperCase()  :"EN";
      if(!localStorage.getItem("lang")){
        localStorage.setItem('lang',lang)
      }
      let updateLocalLanguage =  localStorage.getItem('lang');
      setLanguage(updateLocalLanguage)
      i18n.changeLanguage(updateLocalLanguage);
      setApilanguage(lang)
      setHeadingText(conversationsEG?.[`${updateLocalLanguage}`][1]);
      setCommunityUrls(data?.data?.languageDetails?.communityUrl)
      setShowButton(lang != 'EN')
    } catch (err) {
      console.log(err);
    }
  };
  const handleLanguage = ()=>{
    if(localStorage.getItem('lang')=='EN')
    {
      localStorage.setItem('lang',apilanguage)
    } else{
      localStorage.setItem('lang',"EN")
    }
    window.location.href='/';
  }
  useEffect(()=>{
    if(localStorage.getItem('lang')=== 'EN')
    {
      setButtonText(ButtonTexts?.[`${apilanguage}`])
      setHeadingText(conversationsEG?.[`${localStorage.getItem('lang')}`]?.[1])
    }
  },[apilanguage])

  useEffect(() => {
    console.log(conversationsEG?.[`${localStorage.getItem('lang')}`]?.[1], "sanyaaa");
    i18n.changeLanguage(localStorage.getItem('lang'));
    setHeadingText(conversationsEG?.[`${localStorage.getItem('lang')}`]?.[1]);
    setHeadingTexts(conversationsEG?.[`${language}`]);
    let index = 0;
    const interval = setInterval(() => {
      if (index < headingTexts?.length - 1) {
        setHeadingText(headingTexts[index]);
        index++;
      } else {
        index = 0;
        setHeadingText(headingTexts?.[index]);
      }
    }, 2000);

    return () => {
      clearInterval(interval);
    };
  }, [language,headingTexts]);

  return (
    <>
    {
      showButton ? (
        <div className="nav-container">
      <div className="content-box">
        <p>We {language == "EN" ? 'can display' : 'are displaying'} this page in your regional language.</p>
        <div className="nav-lang-box" onClick={handleLanguage}>
          <img src={globe} alt="globe" />
          <p>{buttonText}</p>
        </div>
      </div>
    </div>
      ) : ""
    }
      <div className="desktopScreen mt-10 px-20 min-h-screen">
        <div className="grid grid-cols-2 gap-6">
          <div>
            <div className="fixed w-2/5">
              <img width={200} src={ClassplusLogo} alt="classplus-logo" />
              <h2 className="text-4xl mt-6 font-semibold" style={{color: "#FFE668"}}>
                {instituteName ? (
                  `${t("screens.DesktopScreen.HI","Hi")}, ${instituteName}`
                ) : (
                  <>
                    {/* <span className="border-b-4  border-colorWhite">
                      Create
                    </span>{" "}
                    your Online <br /> presence with Classplus. */}
                    {t("components.Headings.Free Pentab", "Get A Complete Studio Setup!")}
                    {" "}
                    <br />
                    <span className="text-colorWhite  border-colorHeading  " style={{fontSize:"29px" , fontWeight:"500px" , lineHeight:"22px" }}>
                      {t("components.Headings.Book your teaching app","Book your Teaching App today and get a Studio Setup for FREE.")}
                    </span>
                  </>
                )}
              </h2>
            </div>
            <div className="featureContainer" >
                  <img src={tablet} alt="pentab-img" style={{width: "533px",paddingBottom: "0px", position:'fixed', bottom:'0px'}}/>
            </div>
            {showDadaImage ? (
            <div className=" FIXED w-1/3 imgContainerNew" style={{paddingLeft: "351px", width: "994px"}}>
              <img src={SouravDadaImage} alt="sourav-dada"  style={{width: "358px" , position:'fixed', bottom:'0px'}}/>
            </div>
            ) : null}
          </div>
          <div className="p-4">
            <HomeScreen
              desktopView={true}
              setNumberSubmitted={setNumberSubmitted}
              setInstituteName={setInstituteName}
              language={language}
              uids={uid}
              communityUrls={communityUrls}
              hideDadaImage={hideDadaImage}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DesktopScreen;
